import styled from 'styled-components';
import Carousel from 'react-bootstrap/Carousel';

export const StyledCarousel = styled(Carousel)`
  height: 100%;

  .carousel-inner,
  .carousel-item {
    height: 100%;
  }

  .carousel-item {
    background: #f6f8fb;
    text-align: center;
    padding: 8px 16px 56px;
  }

  .carousel-control-prev,
  .carousel-control-next {
    width: auto;
    opacity: 1;
    align-items: flex-end;
    padding: 0 12px 12px;
  }

  .carousel-control-prev {
    justify-content: flex-start;
  }

  .carousel-control-next {
    justify-content: flex-end;
  }
`;

export const StyledButton = styled.span`
  background: rgba(28, 75, 117, 0.95);
  border-radius: 6px;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
`;

export const StyledSlideImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  object-fit: contain;
  object-position: center;
`;
